import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import ReadMore from 'srcReact/components/common2/ReadMore'

export default function Info({ t, link, address, description, isMemberOfGroup }) {
  const executeOnClick = (isExpanded) => {
    console.log('isExpanded:', isExpanded)
  }

  return (
    !isMemberOfGroup && (
      <div className={styles.infoWrapper}>
        <div className={styles.about}>
          <span className={styles.aboutTitle}>{t('global.aboutGroupMixr', { type: t('global.group') })}</span>
          <ReadMore>{description}</ReadMore>
        </div>
      </div>
    )
  )
}
